import React from 'react';
import axios from "../../../containers/api";
import { Link } from "react-router-dom";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Table } from "../../../components/table/Table";
import Config from "../../../constants/config";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
    Badge, Button, Card, CardBody, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input, CustomInput,
    Row, Colx
} from "reactstrap";
import { getkalas, showCatchError, convertDate, toCurrency, toEnglishNumbers } from "../../../helpers/Utils";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
const NumberInput = ({ value, disabled, onChange }) => (
    <Input
        type="number"
        className="text-center"
        value={value ?? ""}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
    />
);
const TableCheckbox = ({ id, checked, onChange }) => (
    <CustomInput
        type="checkbox"
        id={id}
        checked={checked}
        onChange={e => onChange(e.target.checked)}
    />
);

class FinancialBill extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
           
            coefficients: [], 
        };
    }



    componentDidMount() {
        this.GetFinancialBill();
         
        window.scrollTo(0, 0);
    }

    // دریافت مشتریان




    // جستجوی بار
    GetFinancialBill  = () => { 
        this.props.showSpinner();
        axios.post('/api/v1/financial-coefficient-defaults/SearchFinancialCoefficientDefault' )
            .then(res => {
                this.props.hideSpinner();
                const data = res.data.data || [];
                this.setState({ coefficients: data });
                console.log(data)
                this.props.showAlert(
                    data.length === 0
                        ? "موردی یافت نشد"
                        : `${data.length} مورد یافت شد`,
                    data.length === 0 ? "warning" : "success"
                );
            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };

    
    handleSave = () => {
        const { coefficients } = this.state;
        const errors = this.validateCoefficients();

        if (errors.length > 0) {
            alert(errors.join("\n"));
            return;
        }

        if (!coefficients || coefficients.length === 0) {
            this.props.showAlert("هیچ ضریب مالی برای ثبت وجود ندارد", "warning");
            return;
        }

        // آماده کردن داده‌ها
        const payload = {
           
            Coefficients: coefficients.map(c => ({
                FinancialCoefficientTypeId: c.financialCoefficientTypeId,
                IsPercent: c.isPercent,
                PercentageOfRent: c.percentageOfRent,
                IsFixedAmount: c.isFixedAmount,
                FixedAmount: c.fixedAmount,
                DeductedFromDriver: c.deductedFromDriver,
                AddToRent: c.addToRent
            }))
        };

        this.props.showSpinner();

        axios.post("/api/v1/financial-coefficient-defaults/AddFinancialCoefficientDefault", payload)
            .then(res => {
                this.props.hideSpinner();
                this.props.showAlert(`${res.data} مورد با موفقیت ثبت شد`, "success");
                this.GetFinancialBill(); // دوباره دیتا رو از سرور می‌گیریم
            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };


     
    //updateItem = (item, field, value) => {
    //    const coefficients = [...this.state.coefficients];
    //    const index = coefficients.findIndex(c => c.financialCoefficientTypeId === item.financialCoefficientTypeId);
    //    if (index === -1) return; // اگر پیدا نشد کاری نکن
    //    coefficients[index][field] = value;
    //    this.setState({ coefficients });
    //};
    updateItem = (item, field, value) => {
        this.setState(prev => ({
            coefficients: prev.coefficients.map(c => {
                if (c.financialCoefficientTypeId !== item.financialCoefficientTypeId)
                    return c;

                const updated = { ...c, [field]: value };

                // وقتی تیک‌ها برداشته میشن، مقدار باکس‌ها خالی بشه
                if (field === "isPercent" && value === false) {
                    updated.percentageOfRent = null;
                }

                if (field === "isFixedAmount" && value === false) {
                    updated.fixedAmount = null;
                }

                return updated;
            })
        }));
    };

    validateCoefficients = () => {
        const errors = [];

        this.state.coefficients.forEach(item => {
            const percent = Number(item.percentageOfRent);
            const fixed = Number(item.fixedAmount);

            // بررسی درصد
            if (item.isPercent) {
                if (item.percentageOfRent === null || item.percentageOfRent === "" || item.percentageOfRent === undefined || percent < 0) {
                    errors.push(`درصد برای «${item.financialCoefficientTypeName}» نمی‌تواند خالی یا منفی باشد`);
                }
            }

            // بررسی مبلغ ثابت
            if (item.isFixedAmount) {
                if (item.fixedAmount === null || item.fixedAmount === "" || item.fixedAmount === undefined || fixed < 0) {
                    errors.push(`مبلغ ثابت برای «${item.financialCoefficientTypeName}» نمی‌تواند خالی یا منفی باشد`);
                }
            }
        });

        return errors;
    };




  
    closeModal = (name) => this.setState({ [name]: false });

    render() {
        
        return (
            <>
                {/* هدر */}
                <Row>
                    <Colxx xxs="12">
                        <h3 className="mb-4">ثبت اطلاعات مالی بارنامه  </h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

           
                <Card className="shadow-sm mt-4">
                    <CardBody>
                        <CardTitle className="text-primary mb-4">
                            ثبت اطلاعات مالی
                        </CardTitle>

                        <Table
                            tableHeaders={[
                                "عنوان",
                                "درصد",
                                "مبلغ ثابت",
                                "٪ از کرایه",
                                "مبلغ ثابت؟",
                                "کسر از راننده",
                                "اضافه به کرایه"
                            ]}
                            tableRow={this.state.coefficients}
                            tableData={[
                                (item) => (
                                    <span className="text-right font-weight-bold">
                                        {item.financialCoefficientTypeName}
                                    </span>
                                ),

                                (item) => (
                                    <NumberInput
                                        value={item.percentageOfRent}
                                        disabled={!item.isPercent}
                                        onChange={(val) =>
                                            this.updateItem(item, "percentageOfRent", val)
                                        }
                                    />
                                ),

                                (item) => (
                                    <NumberInput
                                        value={item.fixedAmount}
                                        disabled={!item.isFixedAmount}
                                        onChange={(val) =>
                                            this.updateItem(item, "fixedAmount", val)
                                        }
                                    />
                                ),

                                (item) => (
                                    <TableCheckbox
                                        id={`isPercent-${item.financialCoefficientTypeId}`}
                                        checked={item.isPercent}
                                        onChange={(checked) =>
                                            this.updateItem(item, "isPercent", checked)
                                        }
                                    />
                                ),

                                (item) => (
                                    <TableCheckbox
                                        id={`isFixedAmount-${item.financialCoefficientTypeId}`}
                                        checked={item.isFixedAmount}
                                        onChange={(checked) =>
                                            this.updateItem(item, "isFixedAmount", checked)
                                        }
                                    />
                                ),

                                (item) => (
                                    <TableCheckbox
                                        id={`deducted-${item.financialCoefficientTypeId}`}
                                        checked={item.deductedFromDriver}
                                        onChange={(checked) =>
                                            this.updateItem(item, "deductedFromDriver", checked)
                                        }
                                    />
                                ),

                                (item) => (
                                    <TableCheckbox
                                        id={`add-${item.financialCoefficientTypeId}`}
                                        checked={item.addToRent}
                                        onChange={(checked) =>
                                            this.updateItem(item, "addToRent", checked)
                                        }
                                    />
                                ),
                            ]}


                        />


                        <div className="text-center mt-4">
                            <Button color="success" size="lg" onClick={this.handleSave}>
                                ذخیره اطلاعات
                            </Button>
                        </div>

                    </CardBody>
                </Card>



            </>
        );
    }
}

export default FinancialBill;